const home = () => {
  $( document ).ready(function() {
    if ($("body").hasClass("index")) {
      $('.marquee').marquee();
  
      $(window).scroll(function(){
        const scrollTop = $(window).scrollTop() - $('.about-bottom').offset().top;
        const scrollBottom = $(window).scrollTop() + $(window).height();
        const contentStartPosition = $('.about-bottom .content').offset().top;
        const endPosition = $('.about-bottom').offset().top + $('.about-bottom').outerHeight(true);
        const windowHeight = $(window).height();
  
        if (scrollTop > 0 && scrollTop < endPosition - windowHeight) {
          const percentage = (scrollTop / windowHeight * 200) < 50 ? (scrollTop / windowHeight * 200) : 50;
          const style = `translate(-${percentage}%, 0%) translate3d(0px, 0px, 0px)`;
          $('#about_video').css('transform', style);
          $('#about_video').addClass('on-scroll');
          $('#about_video').removeClass('end-scroll');
        } if (scrollTop <= 0) {
          $('#about_video').css('transform', 'matrix(1,0,0,1,0,0)');
          $('#about_video').removeClass('on-scroll');
          $('#about_video').removeClass('end-scroll');
        }
  
        
        if (scrollBottom >= endPosition) {
          $('#about_video').css('transform', 'translate(-50%, 0%) matrix(1,0,0,1,0,0)');
          $('#about_video').removeClass('on-scroll');
          $('#about_video').addClass('end-scroll');
        }
      });
  
      $('.testimonial #slick').slick({
        infinite: true,
        slidesToShow: 3,
        slidesToScroll: 1,
        dots: true,
        arrows: false,
        responsive: [{
          breakpoint: 768,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          }
        }]
      });
  
      var waypoints = $('.featured-product .product-image').waypoint({
        handler: function(direction) {
          $(this.element).addClass('show-transition');
        },
        offset: '50%'
      })
    }
  });
}

export default home;
